export const UnpublishedMarker = ({ iconTint }: { iconTint: string }) => {
    return (
        <div
            style={{
                width: '8px',
                height: '8px',
                backgroundColor: iconTint || 'var(--rwl-icon-default)',
                borderRadius: '50%',
            }}
        />
    );
};
